import React, { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Spinner
} from 'reactstrap';
import { deleteOfferStatus } from 'service/offerstatus.service';
import { updateOfferStatus } from 'service/offerstatus.service';
import { addOfferStatus } from 'service/offerstatus.service';
import { getOfferStatus } from 'service/offerstatus.service';

const OfferStatus = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [offerTypeData, setOfferTypeData] = useState([]);
  const [newOfferType, setNewOfferType] = useState({
    value: '',
    label: "",
    id: 0,
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  useEffect(() => {
    fetchOfferTypes();
  }, []);

  const toggleModal = () => {
    setIsUpdate(false);
    setIsSubmitting(false);
    setNewOfferType({ status: '',});
    setModalOpen(!modalOpen);
  };

  const toggleUpdateModal = (offertype) => {
    setNewOfferType(offertype);
    setIsSubmitting(false);
    setIsUpdate(true);
    setModalOpen(!modalOpen);
  };

  const fetchOfferTypes = async () => {
    try {
      const offertype = await getOfferStatus();
      console.log(offertype);
      setOfferTypeData(offertype.data.offerStatusFeed);
    } catch (error) {
      console.error('Error fetching advertisers:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewOfferType((prevData) => ({ ...prevData, [name]: value }));

    

    setFormErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  
  };

//   const generateShortName = (text) => {
//     const words = text.trim().split(' ');
//     let initials = '';

//     if (words.length === 1) {
//       const word = words[0].toUpperCase();
//       if (word.length >= 2) {
//         initials = word.substring(0, 2);
//       } else {
//         initials = word.padEnd(2, '_');
//       }
//     } else {
//       words.forEach((word) => {
//         initials += word.charAt(0).toUpperCase();
//       });
//     }
//     setNewOfferType((prevData) => ({ ...prevData, shortName: initials }));
//   };

  const handleFormSubmit =async (e) => {
    e.preventDefault();

    // Perform form validation
    const errors = {};
    if (newOfferType.value.trim() === '') {
      errors.value = 'Value is required';

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    }else{
      setIsSubmitting(true);
      try {
        const addedAdvertiser = await addOfferStatus(newOfferType);
        setIsSubmitting(false);
        setOfferTypeData((prevData) => [...prevData, newOfferType]);
        setNewOfferType({ value: '',label: "",id: 0,  });
        toggleModal();
      } catch (error) {
        console.error('Error adding advertiser:', error);
      }
    }


  };
  const handleFormUpdate =async (e) => {
    e.preventDefault();

    // Perform form validation
    const errors = {};
    if (newOfferType.value.trim() === '') {
      errors.value = 'Name is required';

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    }else{
      setIsSubmitting(true);
      console.log(newOfferType);
      try {
        const addedAdvertiser = await updateOfferStatus(newOfferType.id, newOfferType);
        setIsSubmitting(false);
        fetchOfferTypes()
        toggleModal();
      } catch (error) {
        console.error('Error adding advertiser:', error);
      }
    }


  };
  const handleDeleteOfferType = async (id) => {
    try {
      await deleteOfferStatus(id);
      setOfferTypeData((prevData) => prevData.filter((advertiser) => advertiser.id !== id));
    } catch (error) {
      console.error('Error deleting advertiser:', error);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="row">
        <Card>
          <CardHeader className="d-flex justify-content-between">
            <h5>Offer Status</h5>
            <Button color="secondary" onClick={toggleModal}>
              <i className="ni ni-fat-add" /> Offer Status
            </Button>
          </CardHeader>

          <div className="p-4">
          <Table responsive>
              <thead>
                <tr>
                <th>##</th>
                  <th>Label</th>
                  <th>Value</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {offerTypeData.map((offertype, index) => (
                  <tr key={index}>
                    <td className='text-bold'>#{index+1}</td>
                    <td>
                    
                  <span>{offertype.label}</span>
                 
                    </td>
                    <td>
                    
                  <span>{offertype.value}</span>
                 
                    </td>
                  
                  
                    <td class="text-sm">
                      <Button color='success' className=" btn btn-sm mx-3 text-white" onClick={()=>toggleUpdateModal(offertype)} >
                      <i class="fas fa-user-edit " aria-hidden="true"></i>
                      </Button>
                      <Button color='danger' className='btn btn-sm text-white'  onClick={() => handleDeleteOfferType(offertype.id)}>
                      <i class="fas fa-trash" aria-hidden="true"></i>
                      </Button>
                      </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card>

        <Modal isOpen={modalOpen} toggle={toggleModal} size="md">
          <ModalHeader toggle={toggleModal}>Add/Update Offer Status</ModalHeader>
          <ModalBody>
            <form onSubmit={handleFormSubmit}>
              <FormGroup>
                <Label for="name">Label</Label>
                <Input
                  type="text"
                  name="label"
                  id="label"
                  value={newOfferType.label}
                  onChange={handleInputChange}
                  invalid={!!formErrors.label}
                />
                {formErrors.label && <FormFeedback>{formErrors.label}</FormFeedback>}
              </FormGroup>
              <FormGroup>
                <Label for="name">Value</Label>
                <Input
                  type="text"
                  name="value"
                  id="value"
                  value={newOfferType.value}
                  onChange={handleInputChange}
                  invalid={!!formErrors.value}
                />
                {formErrors.value && <FormFeedback>{formErrors.value}</FormFeedback>}
              </FormGroup>
              
            </form>
          </ModalBody>
          <ModalFooter>
            { !isUpdate?
            <Button color="primary" onClick={handleFormSubmit} disabled={isSubmitting} >
            {isSubmitting ? <Spinner size="sm" color="light" /> : 'Submit'}
            </Button>
            :  <Button color="primary" onClick={handleFormUpdate} disabled={isSubmitting} >
            {isSubmitting ? <Spinner size="sm" color="light" /> : 'Update'}
            </Button>
            }
            <Button color="secondary" onClick={toggleModal}>
              Close
            </Button>
          
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default OfferStatus;
